import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";

/**
 * A weak map to hold anchor tokens.
 */
var ANCHOR = new WeakMap();
/**
 * A weak map to hold focus tokens.
 */

var FOCUS = new WeakMap();
/**
 * All tokens inherit from a single constructor for `instanceof` checking.
 */

export var Token = function Token() {
  _classCallCheck(this, Token);
};
/**
 * Anchor tokens represent the selection's anchor point.
 */

export var AnchorToken = /*#__PURE__*/function (_Token) {
  _inherits(AnchorToken, _Token);

  var _super = _createSuper(AnchorToken);

  function AnchorToken() {
    var _this;

    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, AnchorToken);

    _this = _super.call(this);
    var offset = props.offset,
        path = props.path;
    _this.offset = offset;
    _this.path = path;
    return _this;
  }

  return AnchorToken;
}(Token);
/**
 * Focus tokens represent the selection's focus point.
 */

export var FocusToken = /*#__PURE__*/function (_Token2) {
  _inherits(FocusToken, _Token2);

  var _super2 = _createSuper(FocusToken);

  function FocusToken() {
    var _this2;

    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, FocusToken);

    _this2 = _super2.call(this);
    var offset = props.offset,
        path = props.path;
    _this2.offset = offset;
    _this2.path = path;
    return _this2;
  }

  return FocusToken;
}(Token);
/**
 * Add an anchor token to the end of a text node.
 */

export var addAnchorToken = function addAnchorToken(text, token) {
  var offset = text.text.length;
  ANCHOR.set(text, [offset, token]);
};
/**
 * Get the offset if a text node has an associated anchor token.
 */

export var getAnchorOffset = function getAnchorOffset(text) {
  return ANCHOR.get(text);
};
/**
 * Add a focus token to the end of a text node.
 */

export var addFocusToken = function addFocusToken(text, token) {
  var offset = text.text.length;
  FOCUS.set(text, [offset, token]);
};
/**
 * Get the offset if a text node has an associated focus token.
 */

export var getFocusOffset = function getFocusOffset(text) {
  return FOCUS.get(text);
};